import { isZero, subtract } from "dinero.js";
import React from "react";
import { t } from "ttag";

import { IOrder } from "../../../models/checkout";
import { format } from "../../../utils/format";

interface IProps {
    order: IOrder;
    disableFreeShippingMessage?: boolean;
}

// TODO(i18n): buildRow should not accept pre-translated label string; it prevents proper context and forces early translation. Consider accepting a translation key or element instead.
const buildRow = (label: string, value: string): React.ReactNode => {
    return (
        <span className="basket-summary-line">
            <dt className="basket-summary-line__title">{label}</dt>
            <dd className="basket-summary-line__data">{value}</dd>
        </span>
    );
};

export const OrderSummary = (props: IProps): React.ReactNode => {
    const totalDiscount = subtract(
        props.order.basket_total_before_discounts_excl_tax,
        props.order.basket_total_excl_tax,
    );
    const totalTax = subtract(
        props.order.total_incl_tax,
        props.order.total_excl_tax,
    );
    return (
        <div className="">
            <dl className="basket-summary__prices">
                {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                {buildRow(
                    t`Subtotal`,
                    format.money(
                        props.order.basket_total_before_discounts_excl_tax,
                    ),
                )}
                {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                {!isZero(totalDiscount) &&
                    buildRow(t`Total Savings`, format.money(totalDiscount))}
                {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                {buildRow(
                    t`Shipping`,
                    format.money(props.order.shipping_incl_tax),
                )}
                {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                {buildRow(t`Tax`, format.money(totalTax))}
                {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                {buildRow(t`Total`, format.money(props.order.total_incl_tax))}
            </dl>
        </div>
    );
};
